module.exports = __webpack_public_path__ + "media/images/workplace/patterns/christmas-6b690ed31466df68a70293afb7b070a6.png";